import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { apiConfig, auth0Config } from "../config";
import { getBasicAuthConfig } from "./authUtils";
import { Organization } from "../types/organization";

class UserApi {
  private auth0Client: Auth0Client | null = null;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
  }

  async getOrganazitionsForUser(userId: string): Promise<Organization[]> {
    try {
      const config = await getBasicAuthConfig(this.auth0Client);
      const data: Organization[] = [];
      const response = await axios.get(
        `${apiConfig.providerServiceBase}/practitioners/${userId}/organizations`,
        config,
      );
      if (response.data) {
        data.push(...response.data);
      }
      return data;
    } catch (e) {
      console.error(
        `Error when retrieving organizations for the provider with userID${userId}. Error: ${JSON.stringify(
          e,
        )}`,
      );
    }
  }
}

export const userApi = new UserApi();
